import React from 'react';
import { Link, NavLink } from 'react-router-dom'
import Logo from '../Component/Logo';
import LogoMini from '../Component/Logo-mini';

/**
 * Navigation is grouped under section labels rather than listed flat, so it
 * stays scannable as modules are added — "where do I manage articles?" is
 * answered by the Content group instead of by reading every item.
 */
const NAV_GROUPS = [
    {
        title: 'Overview',
        items: [
            { to: '/Home', icon: 'bx bxs-home', label: 'Dashboard' },
        ],
    },
    {
        title: 'Content',
        items: [
            // `end`: without it React Router marks /Blog active on
            // /Blog/Categories too, highlighting two items at once.
            { to: '/Blog', icon: 'bx bxs-book-content', label: 'Blog', end: true },
            { to: '/Blog/Categories', icon: 'bx bxs-purchase-tag', label: 'Blog Categories' },
            { to: '/News', icon: 'bx bxs-news', label: 'News' },
            { to: '/Stamps', icon: 'bx bxs-image-alt', label: 'Stamps' },
        ],
    },
    {
        title: 'People',
        items: [
            { to: '/Users', icon: 'bx bxs-user', label: 'Users' },
        ],
    },
]

const Sidebar = ({ sidebar }) => {
    return (
        <>
            <div className={sidebar ? "sidebar-wrapper active" : "sidebar-wrapper"}>
                <div className="sidebar-header">
                    <div className="d-flex justify-content-between">
                        <div className='sidebar-logo'>
                            <Link to="/Home">
                                <Logo />
                                <LogoMini />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="sidebar-menu">
                    <ul className="menu">
                        {NAV_GROUPS.map((group) => (
                            <React.Fragment key={group.title}>
                                <li className="sidebar-group-title">{group.title}</li>
                                {group.items.map((item) => (
                                    <li className="sidebar-item" key={item.to}>
                                        <NavLink to={item.to} end={item.end} className='sidebar-link'>
                                            <i className={item.icon}></i>
                                            <span>{item.label}</span>
                                        </NavLink>
                                    </li>
                                ))}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Sidebar
